import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { engagementApi, track, useViewed } from "@/lib/engagement";
import { displayCat } from "@/lib/readoo";

// 5 cose da sapere oggi: riepilogo delle notizie Readoo più importanti, edizione del mattino.
export function DailyBrief() {
  const [items, setItems] = useState([]);
  useEffect(() => { engagementApi.brief().then((r) => setItems(r.items || [])).catch(() => {}); }, []);
  const ref = useViewed("daily_brief_viewed", items.length > 0);
  if (items.length < 3) return null;
  return (
    <section ref={ref} data-testid="daily-brief" className="rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6">
      <h2 className="font-serif text-xl font-semibold text-onSurface">{items.length} cose da sapere oggi</h2>
      <p className="text-sm text-subtle mb-4">Il necessario per capire la giornata in pochi minuti.</p>
      <ol className="space-y-4">
        {items.map((a, i) => (
          <li key={a.article_id} className="flex gap-3">
            <span className="font-serif text-2xl font-semibold text-brand leading-none w-6 tabular-nums">{i + 1}</span>
            <Link to={a.path} data-testid={`daily-brief-item-${i}`} onClick={() => track("daily_brief_article_clicked", { article_id: a.article_id, pos: i + 1 })} className="group min-w-0">
              <span className="font-mono text-[10px] uppercase tracking-wider text-subtle">{displayCat(a.calcio ? "Calcio" : a.category)}</span>
              <span className="block text-sm sm:text-base font-semibold text-onSurface group-hover:text-brand transition-colors">{a.title}</span>
              {a.summary && <span className="block text-sm text-subtle line-clamp-2">{a.summary}</span>}
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
